import { render, staticRenderFns } from "./headPage.vue?vue&type=template&id=f44cd0da&scoped=true&"
import script from "./headPage.vue?vue&type=script&lang=js&"
export * from "./headPage.vue?vue&type=script&lang=js&"
import style0 from "./headPage.vue?vue&type=style&index=0&id=f44cd0da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44cd0da",
  null
  
)

export default component.exports